<template>
  <div
    id="CreateBasicAccount"
    class="authentication-container"
    :class="{'authentication-container-mobile': isMobileSize}"
  >

    <!-- LEFT SIDE -->

    <left-side v-if="!isMobileSize"/>

    <!-- RIGHT SIDE -->

    <div class="right-side">

      <!-- STEP 1 -->

      <div
        class="step-1"
        v-if="!response"
      >

        <!-- TITLE -->

        <div class="title">
          <h3 class="title-header">Create Account</h3>
        </div>

        <!-- INPUT -->

        <form
          class="content form"
          @submit.prevent="invite"
        >
          <div class="inputs">
            <div class="input-container">
              <label
                for="email"
                class="label"
              >{{ memberMetadata.fields.email.label }}</label>
              <input
                id="email"
                type="email"
                class="primary-input"
                v-model="$v.credentials.email.$model"
                :class="{error: $v.credentials.email.$error}"
              >
              <validation-message
                :validation="$v.credentials.email"
                :metadata="memberMetadata.fields.email"
              />
            </div>
          </div>

          <!-- ACTIONS -->

          <div class="actions">
            <CoreButton
              type="submit"
              :disabled="$v.credentials.$invalid"
              :loading="isLoading"
            >
              Send
            </CoreButton>
          </div>
        </form>

        <!-- GO TO LOGIN -->

        <div class="go-to-login">
          <p>Already have an account?
            <router-link
              to="/login"
              class="link"
            >Log in</router-link>
          </p>
        </div>
      </div>
      <div
        class="step-2"
        v-if="response"
      >
        <div class="title">
          <h3 class="title-header">Create Account</h3>
        </div>
        <div class="content dialog-message">
          <p>We sent an email to <span class="response"> {{ credentials.email }} </span> Click the link provided in the email to verify your email and to continue creating your account.</p>
        </div>
        <div>
          <p class="p-left-50">
            Didn’t receive an email?<span
              class="link"
              @click="invite"
            >Resend Email</span>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import server, { createValidator } from './../server'
import { mixin as clickout } from 'vue-clickout'
import { GatewayService } from '../utils/request'
import { createToastNotification } from '../utils/toast'
import { WaitStates } from '../utils/vuewait'
import { DEFAULT_APPLICATION_ID, DEFAULT_SCOPES, DEFAULT_REDIRECT_URL } from '../settings'

const CoreButton = () => import(
  /* webpackChunkName: "CoreButton" */ './../components/Core/CoreButton.vue'
)
const LeftSide = () => import(
  /* webpackChunkName: "LeftSide" */ './../components/LeftSide'
)
const ValidationMessage = () => import(
  /* webpackChunkName: "ValidationMessage" */ './../components/ValidationMessage'
)

export default {
  mixins: [clickout],
  name: 'CreateBasicAccount',
  data () {
    return {
      credentials: {
        email: null
      },
      memberMetadata: server.metadata,
      response: null
    }
  },
  validations () {
    return {
      credentials: {
        email: createValidator(this.memberMetadata.fields.email)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$wait.is(WaitStates.CREATE_BASIC_ORGANIZATION_LOADING)
    },
    isMobileSize () {
      return window.innerWidth <= 768
    }
  },
  methods: {
    async invite () {
      const form = {
        email: this.credentials.email,
        scopes: DEFAULT_SCOPES.join(','),
        applicationId: DEFAULT_APPLICATION_ID,
        redirectUri: DEFAULT_REDIRECT_URL,
        plan: 'basic'
      }

      this.$wait.start(WaitStates.CREATE_BASIC_ORGANIZATION_LOADING)
      const { status } = await GatewayService({
        url: 'invitations',
        method: 'INVITE',
        data: form
      })
      this.$wait.end(WaitStates.CREATE_BASIC_ORGANIZATION_LOADING)
      if (status === 204) {
        createToastNotification('OK', { type: 'success', position: 'bottom' })
        this.response = status
      }
    }
  },
  components: {
    LeftSide,
    ValidationMessage,
    CoreButton
  }
}
</script>
